import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import firebase from "firebase/app";
import 'firebase/firestore';
import store from './store';
import { configOptions } from './keys.js';
import i18n from './i18n'
import { initializeAnalytics, initializeAhrefsAnalytics } from './services/analytics'

/**
 * 规范化 URL 重定向
 * 将 www 和 HTTP 版本重定向到 HTTPS non-www 版本
 */
const canonicalDomain = 'cashboomerang.store'
const currentHost = window.location.hostname
const currentProtocol = window.location.protocol
const currentPath = window.location.pathname + window.location.search + window.location.hash

// Only normalize real production hosts. Local development must stay local.
const isProductionHost = currentHost === canonicalDomain || currentHost === `www.${canonicalDomain}`
if (isProductionHost && (currentHost !== canonicalDomain || currentProtocol !== 'https:')) {
  const redirectUrl = `https://${canonicalDomain}${currentPath}`
  if (window.location.href !== redirectUrl) {
    window.location.replace(redirectUrl)
  }
}

Vue.use(BootstrapVueIcons)
Vue.config.productionTip = false

initializeAnalytics()
initializeAhrefsAnalytics()

firebase.initializeApp(configOptions);
console.log("🔥 Firebase Initialized with Project ID:", configOptions.projectId);
console.log("🔥 Storage Bucket:", configOptions.storageBucket);
export const db = firebase.firestore();
db.settings({ cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED });
db.enablePersistence({ synchronizeTabs: true }).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Firestore persistence failed: multiple tabs open');
  } else if (err.code === 'unimplemented') {
    console.warn('Firestore persistence not supported in this browser');
  }
});

import 'firebase/auth';

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !firebase.auth().currentUser) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

let app;

firebase.auth().onAuthStateChanged(async (user) => {
  store.commit('setUser', user);

  if (user) {
    await db.collection('Users').doc(user.uid).set({
      lastLoginAt: new Date(),
      emailVerified: user.emailVerified
    }, { merge: true });

    store.dispatch('fetchUserProfile');
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      i18n,
      db,  // Mount db here
      render: h => h(App)
    }).$mount('#app')
  }
});
